<template>
  <div
    ref="markListModal"
    aria-hidden="true"
    aria-labelledby="markListModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            {{ $t("note.mark_detail") }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <div v-for="question in questionnaire.questions" :key="question.id" class="question">
            <div class="question__title -light">
              {{ question.title }}
            </div>
            <div v-for="(mark, index) in question.mark" :key="index" class="reply">
              <span>{{ setProfileLabel(mark.profile) }} :</span>
              <span>{{ mark.mark }}</span>
            </div>
            <div class="coefficient">
              <span>{{ $t("note.coefficient") }} :</span>
              <span>{{ question.coefficient }}</span>
            </div>
          </div>
          <div class="average">
            <div class="question__title">{{ $t("note.average") }}</div>
            <div v-for="(item, index) in questionnaire.mark" :key="index" class="average_list">
              <div v-for="average in item" :key="average.profile" class="reply">
                <span>{{ setProfileLabel(average.profile) }} :</span>
                <span class="fw-bold">{{ average.mark }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { triadManager } from "@/services/triad/triad-manager";

export default {
  name: "QuestionnaireMarkListModalComponent",
  props: {
    questionnaire: {
      type: Object,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    opened() {
      const container = this.$refs.markListModal;
      const modal = new Modal(container);
      if (this.opened) {
        modal.show();
      } else {
        modal.hide();
        this.$emit("hidden");
      }
    },
  },
  mounted() {
    this.$refs.markListModal.addEventListener("hidden.bs.modal", this.hidden);
  },
  methods: {
    hidden() {
      this.$emit("hidden");
    },

    setProfileLabel(key) {
      return triadManager.setProfileLabel(
        key,
        this.apprenticeProfileLabel,
        this.tutorProfileLabel,
        this.apprenticeMasterProfileLabel,
        this.studeaManagerProfileLabel,
      );
    },
  },
};
</script>

<style scoped lang="scss">
.question {
  margin-bottom: 10px;

  &__title {
    padding: 5px 10px;
    background-color: var(--primary-color);
    border-radius: 6px;
    font-weight: 700;
    color: #fff;

    &.-light {
      opacity: 0.5;
    }
  }
}

.coefficient {
  display: flex;
  justify-content: space-between;
  margin: 5px 10px;
  padding-top: 5px;
  border-top: 1px dashed #bfc9d4;
  font-weight: 700;
}

.reply {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;

  &:nth-child(2n + 1) {
    background-color: $lighter-grey;
  }
}

.average {
  margin-top: 25px;
}
</style>
